import React, { useEffect } from "react";

import { confirmNewEmail } from "services";

import { setLocalKlimVar, useAppType, useNavigate, useParams, useToggleNavs, useTranslation, useUserContext } from "utils";

import { Col, MainPage, Row, Svg, Message as message } from "components";

export const ConfirmNewEmail = () => {
  const { t } = useTranslation("user");
  const navigate = useNavigate();
  const appType = useAppType();
  const { email, token } = useParams<{ email: string; token: string }>();
  const { switchFarm } = useUserContext();

  useToggleNavs(false, appType.mobile);

  const changeEmail = (): void => {
    setLocalKlimVar("token", null);

    // Reset farm id, because if a different user tries to sign in, the old farm id
    // would be used leading to the backend returning 401
    switchFarm(null);
    confirmNewEmail({
      userToken: token || "",
      newEmail: email || "",
    })
      .then((res) => {
        if (res.success) {
          message({ content: t("profileUpdate.changeEmailSuccess"), icon: "tick" });
        } else {
          message({ content: t("profileUpdate.changeEmailFailure"), icon: "error" });
        }
      })
      .finally(() => navigate("/sign-in"));
  };

  useEffect(() => {
    changeEmail();
  }, []); //eslint-disable-line

  return (
    <MainPage pageName={"sign-in-up"} containerClass={appType.mobile ? "small" : ""}>
      <section className="container">
        <Row justify="space-around" align="middle" className="mini-form full-height">
          <Col className="center">
            <Svg svgName="logos/klim_logo_brandmark_and_text_white" className="pulsating" />
          </Col>
        </Row>
      </section>
    </MainPage>
  );
};
